<template>
<transition name="slide">
<component 

@easyGameEvent="activeComponent = $event"

@againEvent="activeComponent = $event"


@successEvent="activeComponent = $event"

@loseEvent="activeComponent = $event"

@withDraw="activeComponent = $event"







:is="activeComponent"
>

</component>
</transition>
</template>

<script>
import EasyGame from './components/EasyGame.vue';
import StartGame from './components/StartGame.vue';
import Success from './components/Success.vue';
import Lose from './components/Lose';
import Withdraw from './components/Withdraw.vue';

export default {
  name: 'App',
  data() {
    return {
      activeComponent : 'start-game',
    }
  },
  components: {
    'easyGame' : EasyGame,
    'startGame' : StartGame,
    'success' : Success,
    'lose' : Lose,
    'withdraw' : Withdraw,
  }
}
</script>

<style>

* {
  padding:0;
  margin: 0;


}

body{
  display: flex;;
  background-color: #867ae9;
  font-family: 'Oswald', sans-serif;
  height: 100vh;
  text-align: center;
  align-items: center;
  justify-content: center;
  
}

.slide-enter {}
.slide-enter-active{
    animation: slide-in  0.2s ease-out forwards;
    opacity:1;
}
.slide-leave {}
.slide-leave-active {
    animation: slide-out 0.2s ease-out forwards;
    opacity:0
}

@keyframes slide-in {
    from{
        transform: translateY(-500px);
    }
    to {
        transform: translateY(0px)
    }
}
@keyframes slide-out {
    from{
        transform: translateY(0px);
    }
    to {
        transform: translateY(-500px)
    }
}
</style>
